import { useRepositoryQuery } from '@mews-commander/data-access';
import { FilterValueKey, ProductCheckListFilterValues } from '../components/panels/ProductCheckListFilterFields/types';
import { getProductIdsFromFilters, getReservationFiltersQueryParam } from '../utils/productChecklistQueryParams';
import { useDateRangeBySelectedFilterDate } from '../utils/useDateRangeBySelectedFilterDate';

export const useProductCheckListStatisticsQuery = (filters: ProductCheckListFilterValues) => {
    const { startLocal, endLocal } = useDateRangeBySelectedFilterDate(filters[FilterValueKey.date]);

    return useRepositoryQuery('productChecklist', 'statistics', {
        reportIntervalLocal: {
            start: startLocal.value,
            end: endLocal.value,
        },
        productFilters: {
            productIds: getProductIdsFromFilters(filters),
        },
        reservationFilters: getReservationFiltersQueryParam(filters),
    });
};
